import React from "react";
class Checkbox extends React.Component {
  constructor(props) {
    super(props);
    this.onCheckboxChange = this.onCheckboxChange.bind(this);
  }
  onCheckboxChange(event) {
    var value = !this.props.value;
    this.props.onChange(value);
  }
  render() {
    var { onChange, value, className, id, optionLabel, ...newProps } =
      this.props;
    return (
      <label
        className="flex items-center gap-3 cursor-pointer p-3 border rounded-[11px] transition-colors"
        style={{
          borderColor: value ? "var(--primary-color)" : "#e7eaef",
          backgroundColor: value
            ? "color-mix(in srgb, var(--primary-color) 8%, white)"
            : "white",
        }}
      >
        <input
          type="checkbox"
          checked={value}
          className="h-4 w-4 flex-shrink-0 rounded cursor-pointer"
          style={{ accentColor: "var(--primary-color)" }}
          {...newProps}
        />
        <span className="text-sm text-gray-700" lang="fr" translate="yes">
          {optionLabel}
        </span>
      </label>
    );
  }
}

export default Checkbox;
